import moment from 'moment'
import { prettyUrlParam } from '../../../helpers'

const adminTable = (module) => {
  return {
    id: module.id,
    name: module.name,
    description: module.description,
    status: module.is_active ? 'active' : 'inactive',
    created: moment(module.created_at).unix(),
    updated: moment(module.updated_at).unix(),
    components: module.components,
    relations: {
      media: module.media,
      groups: module.groups,
      members: module.members
    }
  }
}

const clientTable = (module) => {
  return {
    id: module.id,
    name: module.name,
    description: module.description,
    mainImage: module.main_image
  }
}

export default {
  set (state) {
    let set = []
    for (const view in state.views) {
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      set = set.concat(data)
    }

    return set
  },

  complete (state) {
    return state.complete.ids.map((id) => state.complete.index[id])
  },

  view (state) {
    return (view) => {
      const isClient = view === state._clientView
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      if (isClient) {
        return data.map(clientTable)
      }
      return data.map(adminTable)
    }
  },

  byPrettyUrlName (state, getters) {
    return (prettyName) => {
      return getters.set.find((module) => {
        return prettyUrlParam(module.name) === prettyName
      })
    }
  },

  exists (state, getters) {
    return (id) => {
      const module = getters.set.find((module) => {
        return module.id === id
      })
      return typeof(module) !== 'undefined'
    }
  },

  forClientByID (state, getters) {
    return (id) => {
      const module = getters.set.find((module) => {
        return module.id === id
      })

      return clientTable(module)
    }
  },

  unsavedChanges (state) {
    const current = state.current
    const formFields = state.forms.update.fields
    let unsaved = false

    if (!current) {
      return unsaved
    }

    // replacing the main image with a new upload
    if (formFields.image !== null || formFields.imageName) {
      unsaved = true
    }

    // replacing the main image from the library
    if (formFields.imageID !== null && current.main_image === null) {
      unsaved = true
    }

    if (
      formFields.imageID !== null &&
      current.main_image !== null &&
      formFields.imageID !== current.main_image.id
    ) {
      unsaved = true
    }

    if (formFields.name && current.name !== formFields.name) {
      unsaved = true
    }

    if (formFields.description && current.description !== formFields.description) {
      unsaved = true
    }

    if (formFields.active !== null && Number(current.is_active) !== Number(formFields.active)) {
      unsaved = true
    }

    return unsaved
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/modules/getters.js